/* eslint-disable */
import Vue from 'vue';
import VCalendar from 'v-calendar';

Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
  locale: 'pt-br',
  masks: {
    title: 'MMMM "de" YYYY'
  },
  firstDayOfWeek: 1,
});
